export const FacebookIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 14 28" {...props}>
			<use href="/images/icons.svg#vlw-facebook" />
		</svg>
	)
}
